export default `
<feed-item class="compressed" item='discussion' ng-repeat='discussion in topicsStore.feedItems' relevant-time="last_commented_at"></feed-item>
<ut-load-more (load-more)="topicsStore.loadMore()" [is-loading]="topicsStore.isLoading" [is-last-page]="topicsStore.isLastPage"></ut-load-more>
`;
